<template lang="html">
  <article
    :key="project.key"
    :id="project.id"
    :class="slideAdditionalClasses"
    class="c-slider__item"
    >
    <slider-item-infos :project="project"></slider-item-infos>
    <slider-item-background :tempCurrentIndex="slideCurrentIndex" :project="project"></slider-item-infos>
  </article>
</template>

<script>
import {mapGetters} from 'vuex'

import { TweenLite, Power2 } from 'gsap'

import SliderItemInfos from './SliderItemInfos'
import SliderItemBackground from './SliderItemBackground'

export default {
  components: {
    SliderItemInfos,
    SliderItemBackground
  },
  props: {
    project: {
      type: Object
    }
  },
  data () {
    return {
      tempCurrentIndex: null,
      requestedTranslate: {
        init: null,
        hover: null
      },
      currentTranslate: {
        hover: null
      },
      currentlyTranslatingSlide: false
    }
  },
  computed: {
    ...mapGetters([
      'touchDevice',
      'currentIndex',
      'nextIndex',
      'prevIndex',
      'toggleHover',
      'direction',
      'requestedIndex'
    ]),
    slideCurrentIndex () {
      return this.tempCurrentIndex
    },
    slideAdditionalClasses () {
      return {
        's-current': this.tempCurrentIndex === this.project.key,
        's-requested': this.nextIndex === this.project.key || this.prevIndex === this.project.key
      }
    }
  },
  watch: {
    nextIndex () {
      if (this.nextIndex === this.project.key) {
        this.setSlidePosition('next')
      }
    },
    prevIndex () {
      if (this.prevIndex === this.project.key) {
        this.setSlidePosition('prev')
      }
    },
    toggleHover () {
      if (!this.currentlyTranslatingSlide && !this.touchDevice) {
        // Preset translates values
        if (this.tempCurrentIndex === this.project.key) {
          if (this.direction === 'next') {
            this.currentTranslate.hover = '-5%'
          } else if (this.direction === 'prev') {
            this.currentTranslate.hover = '5%'
          }
        }

        if (this.toggleHover !== false) {
          if (this.direction === 'next' && this.nextIndex === this.project.key) {
            this.requestedHoverIn()
          } else if (this.direction === 'prev' && this.prevIndex === this.project.key) {
            this.requestedHoverIn()
          }

          if (this.tempCurrentIndex === this.project.key) {
            this.currentHoverIn()
          }
        } else {
          if (this.direction === 'next' && this.nextIndex === this.project.key) {
            this.requestedHoverOut()
          } else if (this.direction === 'prev' && this.prevIndex === this.project.key) {
            this.requestedHoverOut()
          }

          if (this.tempCurrentIndex === this.project.key) {
            this.currentHoverOut()
          }
        }
      }
    },
    currentIndex () {
      if (!this.currentlyTranslatingSlide) {
        this.currentlyTranslatingSlide = true

        if (this.project.key === this.currentIndex) {
          this.slideIn(() => {
            this.$children[0].showText()
          })
        }
        if (this.project.key === this.tempCurrentIndex) {
          this.slideOut(() => {
            this.$parent.rebindAllSlides()
          })
        }
      }
    }
  },
  methods: {
    reInitSlide () {
      this.currentlyTranslatingSlide = false

      if (this.tempCurrentIndex !== this.project.id) {
        this.clearOpcaityAndScale()
      }

      this.tempCurrentIndex = this.currentIndex
    },
    setSlidePosition (direction) {
      if (direction === 'next') {
        this.requestedTranslate.init = '100%'
        this.requestedTranslate.hover = '90%'
      } else if (direction === 'prev') {
        this.requestedTranslate.init = '-100%'
        this.requestedTranslate.hover = '-90%'
      }

      TweenLite.set(this.$el, {
        x: this.requestedTranslate.init
      })
    },
    requestedHoverIn () {
      // Show a little bit of the component
      TweenLite.to(this.$el, 0.55, {
        x: this.requestedTranslate.hover,
        ease: Power2.easeOut
      })
    },
    requestedHoverOut () {
      // Hide component
      TweenLite.to(this.$el, 0.65, {
        x: this.requestedTranslate.init,
        ease: Power2.easeOut
      })
    },
    currentHoverIn () {
      // Translate currentIndex component
      TweenLite.to(this.$el, 0.55, {
        x: this.currentTranslate.hover,
        // opacity: 0.4,
        ease: Power2.easeOut
      })
    },
    currentHoverOut () {
      // Translate back currentIndex component
      TweenLite.to(this.$el, 0.65, {
        x: '0%',
        opacity: 1,
        ease: Power2.easeOut
      })
    },
    slideIn (callback) {
      // Show completly component
      TweenLite.to(this.$el, 0.35, {
        x: '0%',
        ease: Power2.easeInOut,
        onComplete: callback
      })
    },
    slideOut (callback) {
      // Hide completly component
      TweenLite.to(this.$el, 0.55, {
        // opacity: 0,
        // scale: 0.9,
        ease: Power2.easeOut,
        onComplete: callback
      })
    },
    clearOpcaityAndScale () {
      TweenLite.set(this.$el, {
        opacity: 1,
        scale: 1
      })
    },
    clearTranslate () {
      TweenLite.set(this.$el, {
        x: '0%'
      })
    }
  },
  mounted () {
    this.tempCurrentIndex = this.currentIndex

    // On load first time setSlidePosition
    if (this.nextIndex === this.project.key) {
      this.setSlidePosition('next')
    } else if (this.prevIndex === this.project.key) {
      this.setSlidePosition('prev')
    }
  }
}
</script>

<style lang="scss">
.c-slider__item {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  opacity: 0;
  pointer-events: none;

  &.s-current, &.s-requested {
    opacity: 1;
    pointer-events: all;
  }

  &.s-current {
    z-index: 10;
  }

  &.s-requested {
    z-index: 30;
  }
}
</style>



// WEBPACK FOOTER //
// SliderItem.vue?0ed06336